import { HTMLProps, ReactNode } from 'react';

import { getDOMProps } from 'app/shared/utils/react';
import styled from 'styled-components';

import NoDataSvg from 'app/shared/svg/no_data.svg';
import { Paper } from '@mui/material';
import { U21Typography } from 'app/shared/u21-ui/components/display/typography/U21Typography';

export interface U21NoDataProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
}

export const U21NoData = (props: U21NoDataProps) => {
  const { children = 'There is nothing to show here...', ...rest } = props;
  return (
    <Container {...getDOMProps(rest)}>
      <NoDataSvg />
      <StyledU21Typography>{children}</StyledU21Typography>
    </Container>
  );
};

const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 8px;
`;

const StyledU21Typography = styled(U21Typography)`
  margin-top: 8px;
`;
